import ProgressBar from "react-bootstrap/ProgressBar";
const Progress = ({ progress }) => {
  return (
    <div className="progress_bar">
      <ProgressBar animated now={progress} label={`${progress} %`} />
    </div>
  );
};

export default Progress;
